import TableTools from "@/utils/tableTools";
import mesureEnum from "@/model/mesureEnum";
import dimensionEnum from "@/model/dimensionEnum";
import {
  columnTypeEnum,
  calculatedColumnsEnum,
  alternativeColumnLabelEnum,
} from "@/model/columnsEnums";
import { kioskGlobalHelper } from "@/utils/kioskGlobalHelper";

export default {
  namespaced: true,
  state: {
    dimensionColumnsTables: [],
    measureColumnsTables: [],
    defaultSortedColumnTables: "",
    tablesData: [],
    dataReadyTables: false,
  },
  mutations: {
    setDimensionColumnsTables(state, data) {
      state.dimensionColumnsTables = data;
    },
    setMeasureColumnsTables(state, data) {
      state.measureColumnsTables = data;
    },
    setDefaultSortedColumnTables(state, data) {
      state.defaultSortedColumnTables = data;
    },
    setTablesData(state, data) {
      state.tablesData = data;
    },
    updateTableData(state, payload) {
      state.tablesData = state.tablesData.map((tab) => {
        if (tab.tableHeaderId === payload.siteId) {
          return {
            ...tab,
            dataTable: payload.dataTable,
            totalsData: payload.totalsData,
          };
        }
        return tab;
      });
    },
    setDataReadyTables(state, data) {
      state.dataReadyTables = data;
    },
  },
  actions: {
    resetDataReadyTables({ commit }) {
      commit("setDataReadyTables", false);
    },
    initDisplayTables({ commit }) {
      commit(
        "setDimensionColumnsTables",
        TableTools.Helper.constructColumnTable(
          [dimensionEnum.KIOSK_NAME],
          null,
          columnTypeEnum.DIMENSION,
          true,
          null
        )
      );

      commit(
        "setMeasureColumnsTables",
        TableTools.Helper.constructColumnTable(
          [
            calculatedColumnsEnum.RECEIPTS_TOTAL_AMOUNT,
            calculatedColumnsEnum.TOTAL_REVENUE_PERCENT_SITE,
            mesureEnum.PURCHASEHISTORY_AMOUNTCB,
            calculatedColumnsEnum.PERCENT_TOTAL_CB,
            mesureEnum.PURCHASEHISTORY_AMOUNTCASH,
            calculatedColumnsEnum.PERCENT_TOTAL_CASH,
            alternativeColumnLabelEnum.SNACKHISTORY_AMOUNT_CB_TTC,
            mesureEnum.PURCHASEHISTORY_COUNTSOLDCARDS,
            mesureEnum.PURCHASEHISTORY_TOKEN,
            mesureEnum.PURCHASEHISTORY_BONUSTOKEN,
            calculatedColumnsEnum.BONUS_TOKENS_RATIO,
          ],
          null,
          columnTypeEnum.MEASURE,
          true,
          null
        )
      );

      commit("setDefaultSortedColumnTables", dimensionEnum.KIOSK_NAME);
    },
    async updateTableList({ state, commit, dispatch }, payload) {
      // Initialisation des objets contenant toutes les données pour chaque site :
      // permet d'afficher dès maintenant les entêtes de tableaux et le loader pour indiquer que les requêtes sont en cours
      const tablesData = payload.siteValues.map((site, i) => {
        return {
          tableNumber: i.toString(),
          tableHeader: site.label,
          tableHeaderId: site.id,
          dataTable: [],
          totalsData: {},
        };
      });
      commit("setTablesData", tablesData);

      const queries = kioskGlobalHelper.getQueries(payload.filters, payload.timeDimension);

      const resultSets = await TableTools.Helper.doMultipleRequest(queries);
      const mergedResults = TableTools.Helper.mergeResultsByCommonDimensions(
        resultSets,
        kioskGlobalHelper.dimensions
      );

      await dispatch('initDisplayTables');

      // Complétion des objets avec les données reçues pour chaque site
      payload.siteValues.forEach((site) => {
        let dataTable = mergedResults.filter(
          (result) => result[dimensionEnum.SITE] === site.id
        );

        // Extraire la devise spécifique à ce site
        const siteCurrency = dataTable.length > 0 ? (dataTable[0][dimensionEnum.SITE_CURRENCY] || 'EUR') : 'EUR';

        // Ajouter la devise à chaque ligne pour le formatage
        dataTable.forEach(row => {
          row["Site.currency"] = siteCurrency;
        });
        dataTable = kioskGlobalHelper.addSnackHistoryCbColumns(dataTable);
        let totalsData = TableTools.Helper.calculateTotalsData(
          dataTable,
          state.measureColumnsTables
            .map((col) => col.key)
            .filter(
              (key) =>
                key !== calculatedColumnsEnum.TOTAL_REVENUE_PERCENT_SITE &&
                key !== calculatedColumnsEnum.BONUS_TOKENS_RATIO
            )
        );
        // % du Site
        dataTable = kioskGlobalHelper.addPercentageColumn(
          dataTable,
          totalsData[calculatedColumnsEnum.RECEIPTS_TOTAL_AMOUNT]
        );
        // % CB et % CASH
        ({data: dataTable, total: totalsData} =
          kioskGlobalHelper.addPaymentMethodPercentageColumn(dataTable, totalsData)
        );
        // % Unités bonus
        dataTable = kioskGlobalHelper.addBonusTokenPercentageColumn(dataTable);
        totalsData = kioskGlobalHelper.addBonusTokenTotalPercentage(
          dataTable,
          totalsData
        );
        commit("updateTableData", { siteId: site.id, dataTable, totalsData });
      });
      commit("setDataReadyTables", true);
    },
  },
};
